import React, { useState } from "react";
import "./ColorMatch.css";

const easyColors = [
  { name: "Red", code: "red" },
  { name: "Blue", code: "blue" },
  { name: "Green", code: "green" },
  { name: "Yellow", code: "yellow" },
  { name: "Black", code: "black" },
  { name: "White", code: "white" },
  { name: "Gray", code: "gray" },
  { name: "Brown", code: "brown" },
  { name: "Pink", code: "pink" },
  { name: "Orange", code: "orange" },
  { name: "Purple", code: "purple" },
  { name: "Cyan", code: "cyan" },
  { name: "Magenta", code: "magenta" },
  { name: "Lime", code: "lime" },
  { name: "Indigo", code: "indigo" },
  { name: "Violet", code: "violet" },
  { name: "Gold", code: "gold" },
  { name: "Silver", code: "silver" },
  { name: "Beige", code: "beige" },
  { name: "Maroon", code: "maroon" },
  { name: "Olive", code: "olive" },
  { name: "Navy", code: "navy" },
  { name: "Teal", code: "teal" },
  { name: "Turquoise", code: "turquoise" },
  { name: "Peach", code: "peach" },
  { name: "Lavender", code: "lavender" },
  { name: "Sky Blue", code: "skyblue" },
  { name: "Sea Green", code: "seagreen" },
  { name: "Coral", code: "coral" },
  { name: "Khaki", code: "khaki" },
  { name: "Crimson", code: "crimson" },
  { name: "Mint", code: "mint" },
  { name: "Rose", code: "rose" },
  { name: "Plum", code: "plum" },
  { name: "Ivory", code: "ivory" },
  { name: "Charcoal", code: "charcoal" },
  { name: "Sand", code: "sand" },
  { name: "Mustard", code: "mustard" },
  { name: "Copper", code: "copper" },
  { name: "Bronze", code: "bronze" },
  { name: "Aquamarine", code: "aquamarine" },
  { name: "Periwinkle", code: "periwinkle" },
  { name: "Ruby", code: "ruby" },
  { name: "Emerald", code: "emerald" },
  { name: "Sapphire", code: "sapphire" },
  { name: "Topaz", code: "topaz" },
  { name: "Amethyst", code: "amethyst" },
  { name: "Honey", code: "honey" },
  { name: "Pearl", code: "pearl" },
  { name: "Snow", code: "snow" }
];

const hardColors = [
  { name: "Chartreuse", code: "chartreuse" },
  { name: "Cerulean", code: "cerulean" },
  { name: "Fuchsia", code: "fuchsia" },
  { name: "Ochre", code: "ochre" },
  { name: "Sepia", code: "sepia" },
  { name: "Carmine", code: "carmine" },
  { name: "Vermilion", code: "vermilion" },
  { name: "Ultramarine", code: "ultramarine" },
  { name: "Mauve", code: "mauve" },
  { name: "Cerise", code: "cerise" },
  { name: "Saffron", code: "saffron" },
  { name: "Tangerine", code: "tangerine" },
  { name: "Persimmon", code: "persimmon" },
  { name: "Cobalt", code: "cobalt" },
  { name: "Indanthrene", code: "indanthrene" },
  { name: "Zaffre", code: "zaffre" },
  { name: "Malachite", code: "malachite" },
  { name: "Viridian", code: "viridian" },
  { name: "Celadon", code: "celadon" },
  { name: "Puce", code: "puce" },
  { name: "Taupe", code: "taupe" },
  { name: "Ecru", code: "ecru" },
  { name: "Gamboge", code: "gamboge" },
  { name: "Titian", code: "titian" },
  { name: "Byzantium", code: "byzantium" },
  { name: "Caput Mortuum", code: "caputmortuum" },
  { name: "Phthalo Blue", code: "phthaloblue" },
  { name: "Phthalo Green", code: "phthalogreen" },
  { name: "Alizarin", code: "alizarin" },
  { name: "Bistre", code: "bistre" },
  { name: "Coquelicot", code: "coquelicot" },
  { name: "Drab", code: "drab" },
  { name: "Ginger", code: "ginger" },
  { name: "Heliotrope", code: "heliotrope" },
  { name: "Jade", code: "jade" },
  { name: "Lapis Lazuli", code: "lapislazuli" },
  { name: "Moss", code: "moss" },
  { name: "Nude", code: "nude" },
  { name: "Onyx", code: "onyx" },
  { name: "Papaya Whip", code: "papayawhip" },
  { name: "Quartz", code: "quartz" },
  { name: "Raspberry", code: "raspberry" },
  { name: "Sangria", code: "sangria" },
  { name: "Tawny", code: "tawny" },
  { name: "Ultramarine Violet", code: "ultramarineviolet" },
  { name: "Wisteria", code: "wisteria" },
  { name: "Xanadu", code: "xanadu" },
  { name: "Yale Blue", code: "yaleblue" },
  { name: "Zinnwaldite Brown", code: "zinnwalditebrown" }
];

export default function ColorMatch() {
  const [mode, setMode] = useState("easy");
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");

  const colors = mode === "easy" ? easyColors : hardColors;

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const handleChoice = (choice, correct) => {
    if (choice === correct) {
      setScore(score + 5);
      setMessage("✅ Correct!");
      correctSound.play();
      if (score + 5 >= 30) { // win condition
        setMessage("🎉 You win! Final Score: " + (score + 5));
        winSound.play();
      }
    } else {
      setScore(score - 2);
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
    }
  };

  return (
    <div className="color-container">
      <h1>🎨 Color Match Game</h1>
      <div className="mode-buttons">
        <button onClick={() => {setMode("easy"); setScore(0); setMessage("");}}>Under 12</button>
        <button onClick={() => {setMode("hard"); setScore(0); setMessage("");}}>Above 12</button>
      </div>
      <p>⭐ Score: {score}</p>
      <p className="status">{message}</p>
      <div className="color-grid">
        {colors.map((item, index) => (
          <div key={index} className="color-card">
            <div className="color-box" style={{backgroundColor: item.code}}></div>
            <div className="choices">
              {colors.map((c, i) => (
                <button key={i} onClick={() => handleChoice(c.name, item.name)}>
                  {c.name}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

